<template>
  <div class="tc pa0 ma0">
    <img :src="imageUrl" :width="width" :alt="project.name" @error="useFallbackImage"/>
  </div>
</template>

<script>
    import { mapState } from 'vuex'
    import _ from 'lodash'
    export default {
        name: 'ProSearchCardThumbnailPhoto',
        props: {
            project: {
                type: Object,
                required: true
            },
            width: {
                type: Number,
                required: false
            },
            height: {
                type: Number,
                required: false
            },
        },
        data() {
            return {
                imageUrl: "",
                errorTriggered: false,
            };
        },
        computed : {
            ...mapState(['env']),
            fallbackImage() {
                return this.height
                    ? `${this.env.projectMediaUrl}/avvay-default-thumb.jpg`
                    : `${this.env.projectMediaUrl}/avvay-default-thumb.jpg`;
            },
        },
        created() {
            const firstMedia = _.head(this.project.media);
            const isYouTube = _.isEqual(firstMedia.type, 'YOUTUBE_VIDEO');
            const isVimeo = _.isEqual(firstMedia.type, 'VIMEO_VIDEO');

            if (isYouTube || isVimeo) {
                this.imageUrl = firstMedia.thumbnailFilePath || this.fallbackImage;
            } else {
                const sizingParams = this.height
                    ? `?w=${this.width}&h=${this.height}&dpr=2&auto=compress&fit=crop&q=50`
                    : `?w=${this.width}&fit=max&dpr=2&auto=compress`;
                this.imageUrl = `${this.env.projectMediaUrl}${firstMedia.filePath}${sizingParams}`;
            }
        },
        methods: {
            useFallbackImage() {
                if (!this.errorTriggered) {
                    this.imageUrl = this.fallbackImage;
                    this.errorTriggered = true;
                }
            },
        },
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/frontend/vue/js/modules/pro/project/components/ProProjectThumbnailPhoto.vue